import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import isFocusedInboxEnabled from 'mini-mail-focused-inbox-config/lib/isFocusedInboxEnabled';
import { generatePath, useSearchParams } from 'mini-react-router-dom';
import { INBOX_FOLDER_NAME } from 'mini-mail-common/lib/utils/folderNameConstants';
import {
    isFolderTableInitialized,
    isValidMailFolderId,
    selectFolder,
} from 'mini-mail-folder-actions';
import { type MailRoutes } from 'mini-routes';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'mini-react-router-dom';

export const useHandleMailFolderNavigation = () => {
    const navigate = useNavigate();
    const { folderId } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const folderTableInitialized = isFolderTableInitialized();

    useEffect(() => {
        // Skip the effect if folderTable is not yet initialized
        if (!folderTableInitialized) {
            return;
        }

        const decodedFolderId = decodeURIComponent(folderId);
        const effectiveFolderId = folderNameToId(decodedFolderId) || decodedFolderId;

        if (!effectiveFolderId || !isValidMailFolderId(effectiveFolderId)) {
            navigate(generatePath('/:folderId', { folderId: INBOX_FOLDER_NAME }), {
                replace: true,
            });
        } else {
            let selectedFilter = -1;
            const shouldShowFocusedOther =
                isFocusedInboxEnabled() && folderId === INBOX_FOLDER_NAME;
            if (shouldShowFocusedOther) {
                const viewFilter = searchParams.get('focusedFilter')?.toLowerCase() ?? 'focused';
                selectedFilter = viewFilter === 'focused' ? 0 : 1;
            }

            selectFolder(effectiveFolderId, selectedFilter);

            // Cleanup the focusedFilter query parameter if user is conditions are not met
            if (!shouldShowFocusedOther && searchParams.get('focusedFilter')) {
                searchParams.delete('focusedFilter');
                setSearchParams(searchParams, { replace: true });
            }
        }
    }, [folderId, navigate, searchParams, setSearchParams, folderTableInitialized]);
};
